import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgEnvelopeClose = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 20 20'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <mask
      id='envelope-close_svg__a'
      width={20}
      height={14}
      x={0}
      y={3}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill={props.color}
        fillRule='evenodd'
        d='M15.833 3.334a3.333 3.333 0 0 1 3.333 3.333v6.667a3.333 3.333 0 0 1-3.334 3.333H4.166a3.333 3.333 0 0 1-3.333-3.334V6.668a3.333 3.333 0 0 1 3.333-3.333zm-4.547 8.533a2.5 2.5 0 0 1-2.573 0L2.499 8.138v5.196c0 .92.746 1.666 1.667 1.666h11.667c.92 0 1.666-.746 1.666-1.666V8.138zM4.166 5c-.77 0-1.416.522-1.607 1.23l7.011 4.208a.83.83 0 0 0 .858 0l7.012-4.207A1.666 1.666 0 0 0 15.832 5z'
        clipRule='evenodd'
      />
    </mask>
    <g mask='url(#envelope-close_svg__a)'>
      <path fill={props.color} d='M0 0h20v20H0z' />
    </g>
  </svg>
)
const ForwardRef = forwardRef(SvgEnvelopeClose)
export default ForwardRef
